import type { ViewEntity } from '@view-model/domain/view/ViewEntity';
import type { Workspace } from '@workspace/domain/workspace';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import { ViewItem } from '../items';
import { useSidebarView } from './useSidebarView';

type Props = {
  view: ViewEntity;
  workspace: Workspace;
  viewModel: ViewModelEntity;
};

export const SidebarTreeViewItemContainer: React.FC<Props> = ({ view, workspace, viewModel }: Props) => {
  const { isSelected } = useSidebarView(view.id);

  return <ViewItem view={view} isSelected={isSelected} workspace={workspace} viewModel={viewModel} />;
};
